import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";

import { InviteListConfig } from "../../../../shared";

@Component({
  selector: "invite-manager-nav-tabs",
  templateUrl: "./invite-manager-nav-tabs.component.html",
  styleUrls: [
    "./invite-manager-nav-tabs.component.scss",
    "../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteManagerNavTabsComponent implements OnInit {
  public ReceivedInvites: HTMLElement;
  public SentInvites: HTMLElement;

  constructor() {}

  @Input() config: InviteListConfig;
  @Output() setListTo = new EventEmitter<any>();

  ngOnInit() {
    this.ReceivedInvites = document.getElementById("ReceivedInvites");
    this.SentInvites = document.getElementById("SentInvites");
  }

  public setListType(e: HTMLElement) {
    const tokenListArray = Array.from(e.classList);

    if (tokenListArray.includes("ReceivedInvites") === true) {
      this.setListTo.emit({ type: "received" });
    }

    if (tokenListArray.includes("SentInvites") === true) {
      this.setListTo.emit({ type: "sent" });
    }
  }
}
